// extracted by mini-css-extract-plugin
export default {"termBodyWrap":"AcademicTrackPhasesAndShifts_termBodyWrap__vI+Zl","termItem":"AcademicTrackPhasesAndShifts_termItem__aR0qy","termBody":"AcademicTrackPhasesAndShifts_termBody__W-7h3"};